import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface VersionState {
    currentVersion: string;
    lastSeenVersion: string | null;
    shouldShowChangelog: boolean;
}

const initialState: VersionState = {
    currentVersion: '',
    lastSeenVersion: null,
    shouldShowChangelog: false
};

const appVersionSlice = createSlice({
    name: 'appVersion',
    initialState,
    reducers: {
        initializeAppVersion: (state, action: PayloadAction<string>) => {
            const currentVersion = action.payload;

            if (state.lastSeenVersion !== currentVersion) {
                state.lastSeenVersion = currentVersion;
                state.shouldShowChangelog = true;
            }

            state.currentVersion = currentVersion;
        },
        markVersionAsSeen: (state) => {
            if (state.currentVersion) {
                state.lastSeenVersion = state.currentVersion;
                state.shouldShowChangelog = false;
            }
        }
    }
});

export const { initializeAppVersion, markVersionAsSeen } = appVersionSlice.actions;

export const selectAppVersion = (state: RootState) => state.appVersion;

export default appVersionSlice.reducer;
